var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "matching--item",
        _vm.category,
        { "matching--item-clickable": _vm.clickable }
      ],
      on: { click: _vm.onClick }
    },
    [
      _vm.label || _vm.comparisonGroup
        ? _c("div", { staticClass: "label" }, [
            _vm.label ? _c("span", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
            _vm._v(" "),
            _vm.comparisonGroup
              ? _c(
                  "div",
                  { staticClass: "comparison-group" },
                  [
                    _vm.comparisonGroup.irrelevant
                      ? _c("div", [_vm._v("Egal für Kandidat")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.comparisonGroup.none
                      ? _c("div", [_vm._v("Keine erwünscht")])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.comparisonGroup.items, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          class: [
                            "comparison-group-item",
                            { "has-items": item.subItems.length > 0 }
                          ]
                        },
                        [
                          _c("div", {
                            staticClass: "comparison-group-item-title",
                            domProps: { innerHTML: _vm._s(item.label) }
                          }),
                          _vm._v(" "),
                          item.subItems.length > 0
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "comparison-group-item-sub-items mt-1"
                                },
                                _vm._l(item.subItems, function(subItem, i) {
                                  return _c(
                                    "li",
                                    {
                                      key: "sub-item-" + i,
                                      class: { extra: subItem.extra }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(subItem.label) +
                                          "\n\t\t\t\t\t\t"
                                      ),
                                      subItem.subItems.length > 0
                                        ? _c(
                                            "ul",
                                            { staticClass: "mt-1" },
                                            _vm._l(subItem.subItems, function(
                                              subItem,
                                              i
                                            ) {
                                              return _c(
                                                "li",
                                                {
                                                  key: "sub-sub-item-" + i,
                                                  class: {
                                                    extra: subItem.extra
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(subItem.label) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showBar
        ? [
            _c("div", { staticClass: "score-container" }, [
              _vm.sectionCompleted === false && _vm.eligible === true
                ? _c("div", [_vm._v("Hier fehlen noch Infos von dir.")])
                : _vm.maxScore > 0
                ? _c("div", { staticClass: "bar" }, [
                    _c(
                      "div",
                      {
                        staticClass: "inner",
                        style: { width: _vm.percentage + "%" }
                      },
                      [_vm._v(" ")]
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.withPercentage
              ? _c("div", { staticClass: "percentage-container" }, [
                  _vm._v(_vm._s(_vm.percentage) + "%")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.infoText
              ? _c("div", { staticClass: "info-container" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        { name: "b-tooltip", rawName: "v-b-tooltip" }
                      ],
                      attrs: { title: _vm.infoTextComputed }
                    },
                    [_c("Icon", { attrs: { icon: "info" } })],
                    1
                  )
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }